export default (function (gender) {
    if (gender === "M") {
        return "Male";
    }
    else if (gender === "F") {
        return "Female";
    }
    return "Unspecified";
});
